import { render, staticRenderFns } from "./MediaPreview.vue?vue&type=template&id=e36a6f70&lang=pug&"
import script from "./MediaPreview.vue?vue&type=script&lang=js&"
export * from "./MediaPreview.vue?vue&type=script&lang=js&"
import style0 from "./MediaPreview.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/node/authoring/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e36a6f70')) {
      api.createRecord('e36a6f70', component.options)
    } else {
      api.reload('e36a6f70', component.options)
    }
    module.hot.accept("./MediaPreview.vue?vue&type=template&id=e36a6f70&lang=pug&", function () {
      api.rerender('e36a6f70', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/library/MediaPreview.vue"
export default component.exports